import { useTranslation } from 'react-i18next';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import { PlanState } from '@lib/enums/plan';
import { CompanyPlanUpgradeFeatureEnum } from 'graphql-common';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import styles from './AiAssistanceTeaser.module.scss';

export default function AiAssistanceTeaser() {
  const { t } = useTranslation();
  const { handleOpenPlanModal }: ContextProps = useOutletContext();

  return (
    <div className={styles.root}>
      <span className={styles.icon}>
        <MaterialIcon icon="auto_awesome" symbolsOutlined />
      </span>
      <Typography variant="label" className={styles.text}>
        {t('documents-import-ai-teaser')}{' '}
        <strong>{t('documents-import-ai-teaser-strong')}</strong>
      </Typography>
      <Button
        buttonText={t('upgrade-plan')}
        buttonType={ButtonTypes.primaryFilled}
        buttonSize={ButtonSizes.small}
        onClick={() =>
          handleOpenPlanModal(PlanState.Locked, [
            CompanyPlanUpgradeFeatureEnum.AiAssistance,
          ])
        }
      />
    </div>
  );
}
